import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.g2b');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-g2b',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.g2b/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageG2bComponent implements OnInit {
    // 키워드 관리
    public keywords: { text: string; selected: boolean }[] = [
        { text: '인공지능', selected: true },
        { text: 'AI 구축', selected: true },
        { text: '챗봇', selected: false },
        { text: '생성형 AI', selected: false },
    ];
    public newKeyword: string = '';
    public maxKeywords: number = 7;

    // 수집 설정
    public maxPerKeyword: number = 10;

    // 결과
    public notices: any[] = [];
    public keywordStats: any[] = [];
    public totalCollected: number = 0;
    public loading: boolean = false;
    public crawled: boolean = false;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.render();
    }

    // 키워드 추가
    public async addKeyword() {
        const kw = this.newKeyword.trim();
        if (!kw) return;
        if (this.keywords.length >= this.maxKeywords) return;
        if (this.keywords.some(k => k.text === kw)) return;
        this.keywords.push({ text: kw, selected: true });
        this.newKeyword = '';
        await this.service.render();
    }

    // 키워드 삭제
    public async removeKeyword(index: number) {
        this.keywords.splice(index, 1);
        await this.service.render();
    }

    // 키워드 토글
    public async toggleKeyword(index: number) {
        this.keywords[index].selected = !this.keywords[index].selected;
        await this.service.render();
    }

    // 선택된 키워드 수
    public get selectedCount(): number {
        return this.keywords.filter(k => k.selected).length;
    }

    // 크롤링 시작
    public async startCrawl() {
        const selected = this.keywords.filter(k => k.selected).map(k => k.text);
        if (selected.length === 0) return;

        this.loading = true;
        this.crawled = false;
        this.notices = [];
        this.keywordStats = [];
        await this.service.render();

        const { code, data } = await wiz.call("crawl", {
            keywords: JSON.stringify(selected),
            maxPerKeyword: this.maxPerKeyword
        });

        if (code === 200) {
            this.notices = data.notices || [];
            this.keywordStats = data.stats || [];
            this.totalCollected = data.total || 0;
        }

        this.loading = false;
        this.crawled = true;
        await this.service.render();
    }

    public formatBudget(amount: number): string {
        if (!amount) return '-';
        if (amount >= 100000000) {
            return (amount / 100000000).toFixed(1) + '억원';
        }
        if (amount >= 10000) {
            return (amount / 10000).toFixed(0) + '만원';
        }
        return amount.toLocaleString() + '원';
    }

    public formatDate(dt: string): string {
        if (!dt) return '-';
        if (dt.includes('-')) return dt.substring(0, 16);
        if (dt.length >= 12) {
            return dt.substring(0, 4) + '-' + dt.substring(4, 6) + '-' + dt.substring(6, 8) + ' ' + dt.substring(8, 10) + ':' + dt.substring(10, 12);
        }
        return dt;
    }
}

export default PageG2bComponent;